import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7661979d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 7,
  class: "action_btn_box"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 不通过 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("上报车辆信息 ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"10px","font-weight":"700"} }, "请输入不通过的原因", -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "道路运输证", -1))
const _hoisted_16 = { class: "preview_box" }
const _hoisted_17 = { class: "preview_item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "道路运输证正页", -1))
const _hoisted_19 = { class: "preview_item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "道路运输证附页", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "行驶证", -1))
const _hoisted_22 = { class: "preview_box" }
const _hoisted_23 = { class: "preview_item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "行驶证正页", -1))
const _hoisted_25 = { class: "preview_item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "行驶证附页", -1))
const _hoisted_27 = { class: "preview_item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "年检记录", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "车辆图片", -1))
const _hoisted_30 = { class: "preview_box" }
const _hoisted_31 = { class: "preview_item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "前", -1))
const _hoisted_33 = { class: "preview_item" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "后", -1))
const _hoisted_35 = { class: "preview_item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "左", -1))
const _hoisted_37 = { class: "preview_item" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "右", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, {
      title: "行驶证/运输证列表",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          layout: "inline",
          class: "search_box"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "所有人",
              class: "search_item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_search, {
                  value: _ctx.searches.vehicle_travel_owner,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.vehicle_travel_owner) = $event)),
                  "enter-button": "",
                  onSearch: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSearch('vehicle_travel_owner', $event))),
                  placeholder: "搜索"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "运输证拥有者",
              class: "search_item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_search, {
                  value: _ctx.searches.transportation_owner,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searches.transportation_owner) = $event)),
                  "enter-button": "",
                  onSearch: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSearch('transportation_owner', $event))),
                  placeholder: "搜索"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "道路运输证许可证号",
              class: "search_item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_search, {
                  value: _ctx.searches.road_transportation_permit_card,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searches.road_transportation_permit_card) = $event)),
                  "enter-button": "",
                  onSearch: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSearch('road_transportation_permit_card', $event))),
                  placeholder: "搜索"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "车牌号",
              class: "search_item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_search, {
                  value: _ctx.searches.plate_number,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searches.plate_number) = $event)),
                  "enter-button": "",
                  onSearch: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSearch('plate_number', $event))),
                  placeholder: "搜索"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { class: "search_item" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tooltip, null, {
                  title: _withCtx(() => [
                    _hoisted_2
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "dashed",
                      onClick: _ctx.resetSearch
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'status')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_a_badge, {
                color: _ctx.statusText[text].color
              }, null, 8, ["color"]),
              _createElementVNode("span", {
                style: _normalizeStyle({color: _ctx.statusText[text].color})
              }, _toDisplayString(_ctx.statusText[text].name), 5)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'driving_licence')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", null, "号牌号码：" + _toDisplayString(record.vehicle_travel_license_number), 1),
              _createElementVNode("div", null, "所有人：" + _toDisplayString(record.vehicle_travel_owner), 1),
              _createElementVNode("div", null, "车辆识别号：" + _toDisplayString(record.vin), 1)
            ]))
          : _createCommentVNode("", true),
        (column.key === 'licence')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", null, "经营许可证号：" + _toDisplayString(record.road_transportation_permit_card), 1),
              _createElementVNode("div", null, "业户名称：" + _toDisplayString(record.transportation_owner), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'review_time')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(_ctx.formatTime(text)), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'carInfo')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createElementVNode("div", null, "车辆类型：" + _toDisplayString(record.vehicle_type), 1),
              _createElementVNode("div", null, "车牌号码：" + _toDisplayString(record.plate_number), 1),
              _createElementVNode("div", null, "吨/座位：" + _toDisplayString(record.transportation_weight), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'audit')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              text
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, "审核时间：" + _toDisplayString(text.create_time), 1))
                : _createCommentVNode("", true),
              text
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, "审核备注：" + _toDisplayString(text.reason), 1))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'image')
          ? (_openBlock(), _createElementBlock("a", {
              key: 6,
              onClick: () => _ctx.setShow(record, true)
            }, "查看", 8, _hoisted_7))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_a_button, {
                size: "small",
                class: "action_btn",
                onClick: ($event: any) => (_ctx.goDetail(record))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["onClick"]),
              (record.status === 0)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    size: "small",
                    class: "action_btn",
                    onClick: ($event: any) => (_ctx.setVisible(record, true)),
                    danger: true
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_a_popconfirm, {
                title: "确定审核通过吗?",
                "ok-text": "确定",
                "cancel-text": "取消",
                onConfirm: ($event: any) => (_ctx.onAudit(record, true))
              }, {
                default: _withCtx(() => [
                  (record.status === 0)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        size: "small",
                        class: "action_btn"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["onConfirm"]),
              _createVNode(_component_a_popconfirm, {
                title: "确定上报车辆信息吗?",
                "ok-text": "确定",
                "cancel-text": "取消",
                onConfirm: ($event: any) => (_ctx.updateCar(record))
              }, {
                default: _withCtx(() => [
                  (record.status === 1 && record.is_pushed === 0)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        size: "small",
                        class: "action_btn",
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.visible) = $event)),
      title: "审核不通过",
      onOk: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onAudit(_ctx.item, false))),
      onCancel: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setVisible(undefined, false))),
      confirmLoading: _ctx.loading
    }, {
      default: _withCtx(() => [
        _hoisted_13,
        _createVNode(_component_a_textarea, {
          value: _ctx.reason,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.reason) = $event)),
          placeholder: "请输入不通过的原因",
          rows: 4
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible", "confirmLoading"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.show,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.show) = $event)),
      title: "图片",
      width: "1000px",
      footer: null,
      onCancel: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setShow(undefined, false)))
    }, {
      default: _withCtx(() => [
        (_ctx.item)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_a_image_preview_group, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_a_image, {
                        src: _ctx.item?.road_transportation_images.front,
                        height: 200,
                        width: 200
                      }, null, 8, ["src"]),
                      _hoisted_18
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_a_image, {
                        src: _ctx.item?.road_transportation_images.sub,
                        height: 200,
                        width: 200
                      }, null, 8, ["src"]),
                      _hoisted_20
                    ])
                  ])
                ]),
                _: 1
              }),
              _hoisted_21,
              _createVNode(_component_a_image_preview_group, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_a_image, {
                        src: _ctx.item?.vehicle_travel_license_images.front,
                        height: 200,
                        width: 200
                      }, null, 8, ["src"]),
                      _hoisted_24
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_a_image, {
                        src: _ctx.item?.vehicle_travel_license_images.sub,
                        height: 200,
                        width: 200
                      }, null, 8, ["src"]),
                      _hoisted_26
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_a_image, {
                        src: _ctx.item?.vehicle_travel_license_images.record,
                        height: 200,
                        width: 200
                      }, null, 8, ["src"]),
                      _hoisted_28
                    ])
                  ])
                ]),
                _: 1
              }),
              _hoisted_29,
              _createVNode(_component_a_image_preview_group, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_a_image, {
                        src: _ctx.item?.vehicle_images.front,
                        height: 200,
                        width: 200
                      }, null, 8, ["src"]),
                      _hoisted_32
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_a_image, {
                        src: _ctx.item?.vehicle_images.back,
                        height: 200,
                        width: 200
                      }, null, 8, ["src"]),
                      _hoisted_34
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_a_image, {
                        src: _ctx.item?.vehicle_images.left,
                        height: 200,
                        width: 200
                      }, null, 8, ["src"]),
                      _hoisted_36
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_a_image, {
                        src: _ctx.item?.vehicle_images.right,
                        height: 200,
                        width: 200
                      }, null, 8, ["src"]),
                      _hoisted_38
                    ])
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}